import { render, staticRenderFns } from "./medicion-prevalencia-editar.vue?vue&type=template&id=deed0a56&scoped=true&"
import script from "./medicion-prevalencia-editar.vue?vue&type=script&lang=js&"
export * from "./medicion-prevalencia-editar.vue?vue&type=script&lang=js&"
import style0 from "./medicion-prevalencia-editar.vue?vue&type=style&index=0&id=deed0a56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deed0a56",
  null
  
)

export default component.exports